export const NAME_CHARACTER_LIMIT = 18;

export function truncateWithEllipsis(value: string, limit: number = NAME_CHARACTER_LIMIT): string {
  if (value.length <= limit) return value;
  return `${value.slice(0, limit)}...`;
}
